import { render, staticRenderFns } from "./sampleOrderModal.vue?vue&type=template&id=ed1d1406&scoped=true"
import script from "./sampleOrderModal.vue?vue&type=script&lang=js"
export * from "./sampleOrderModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed1d1406",
  null
  
)

export default component.exports